import { ETourId, type ITourConfig } from '../types';

/**
 * Tour shown on the Workspace Settings page.
 *
 * One step:
 * 1. Manage your workspace — highlights the settings sidebar navigation
 */
export const workspaceSettingsTour: ITourConfig = {
  id: ETourId.WORKSPACE_SETTINGS,
  enabled: false, // Disable for now as it doesn't make sense to have this one step only. Revisit after the new designs are implemented.
  steps: [
    {
      id: 'settings-nav-menu',
      target: '[data-tour-id="settings-nav-menu"]',
      titleKey: 'tours.workspaceSettings.navMenu.title',
      descriptionKey: 'tours.workspaceSettings.navMenu.description',
      finishLabelKey: 'tours.workspaceSettings.navMenu.finishLabel',
      position: 'rightTop',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_workspace_settings',
    metadata: {
      tourName: 'Workspace Settings',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
